export const BUTTON_STYLES = {
    wavesEffect: "waves-effect",
    wavesLight: "waves-light",
    block: "btn-block w-100",
    rounded: "btn-rounded",
};

export const BUTTON_SIZES = {
    small: "sm",
    middle: "md",
    large: "lg",
};

export const BUTTON_COLORS = {
    primary: "primary",
    primaryOutline: "outline-primary",
    secondary: "secondary",
    success: "success",
    info: "info",
    warning: "warning",
    danger: "danger",
    dangerOutline: "outline-danger",
    dark: "dark",
    link: "link",
    light: "light",
    transparent: "transparent"
};
